<div class="multiple-image-upload" [formGroup]="form">
  <div class="form-group">
    <label class="parent-label" *ngIf="field?.label">
      {{ field.label }}{{ field.validation?.required ? '*' : '' }}
    </label>
    <div class="upload-container">
      <div
        class="upload-zone"
        [class.upload-zone--has-files]="previews?.length"
      >
        <input
          #fileInput
          (change)="fileChangeEvent($event)"
          type="file"
          class="upload-input d-none"
          [accept]="application.IMAGE_ACCEPT_TYPES"
          multiple
        />
        <div class="upload-zone__content">
          <em class="icon-litebanner-upload upload-zone__icon" aria-hidden="true"></em>
          <div class="upload-zone__title">
            {{ field?.bannerImageType2Title || CommonEnums.ADD_MULTIPLE_IMAGE
            }}{{ field?.validation?.required ? '*' : '' }}
          </div>
          <div class="upload-zone__msg">
            {{ IMAGE_FILE_TYPES_MSG }}
          </div>
          <div class="upload-zone__msg upload-zone__msg--size">
            {{ recommendedSizeMessage }}
          </div>
          <app-button
            (handleButtonClick)="triggerFileInput()"
            [btnField]="{
              type: 'button',
              label: field?.bannerImageType2Label || CommonEnums.SELECT_FILE,
              class: 'btn btn-primary select-file-btn'
            }"
          ></app-button>
        </div>
      </div>
      <mat-grid-list
        *ngIf="previews.length"
        cdkDropListGroup
        class="preview-grid d-flex flex-wrap"
      >
        <mat-grid-tile
          *ngFor="let item of previews; let i = index; trackBy: trackByPreview"
          cdkDropList
          [cdkDropListData]="i"
          [cdkDropListOrientation]="DRAG.DROP_LIST_ORIENTATION"
          [cdkDropListDisabled]="previews.length < application.TWO"
          (cdkDropListDropped)="onPreviewDrop($event)"
          class="preview-grid__tile d-flex"
        >
          <div class="preview-cell" cdkDrag [cdkDragData]="i">
            <ng-template cdkDragPreview>
              <div class="preview-cell preview-cell--drag-preview">
                <div class="preview-cell__img-wrap">
                  <img
                    [src]="getSafePreviewUrl(item.previewUrl)"
                    [alt]="item.file?.name ?? STRINGS.PREVIEW_IMAGE_ALT"
                    class="preview-cell__img"
                  />
                </div>
              </div>
            </ng-template>
            <div class="preview-cell__img-wrap">
              <img
                [src]="getSafePreviewUrl(item.previewUrl)"
                [alt]="item.file?.name ?? STRINGS.PREVIEW_IMAGE_ALT"
                class="preview-cell__img"
                loading="lazy"
              />
              <span
                *ngIf="previews.length >= application.TWO"
                class="preview-cell__drag icon-drag reorder-dash"
                [attr.aria-label]="STRINGS.DRAG_TO_REORDER"
              ></span>
              <button
                type="button"
                class="preview-cell__close"
                (click)="removeAt(i); $event.stopPropagation()"
                [attr.aria-label]="STRINGS.REMOVE_IMAGE"
              >
                &times;
              </button>
            </div>
          </div>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
  </div>
  <app-validation-errors
    [control]="form.get(field.name)"
    [field]="field"
  ></app-validation-errors>
</div>
